"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Trybe
 * This site provides documentation on how to use the Trybe Shop API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
var _1 = require("./");
/**
* @export
* @enum {string}
*/
var CreateDiscountTypeApplicableForEnum;
(function (CreateDiscountTypeApplicableForEnum) {
    CreateDiscountTypeApplicableForEnum["Only"] = "app_only";
    CreateDiscountTypeApplicableForEnum["AndBookingEngine"] = "app_and_booking_engine";
})(CreateDiscountTypeApplicableForEnum = exports.CreateDiscountTypeApplicableForEnum || (exports.CreateDiscountTypeApplicableForEnum = {})); /**
* @export
* @enum {string}
*/
var CreateDiscountTypeAmountTypeEnum;
(function (CreateDiscountTypeAmountTypeEnum) {
    CreateDiscountTypeAmountTypeEnum["Monetary"] = "monetary";
    CreateDiscountTypeAmountTypeEnum["Percentage"] = "percentage";
})(CreateDiscountTypeAmountTypeEnum = exports.CreateDiscountTypeAmountTypeEnum || (exports.CreateDiscountTypeAmountTypeEnum = {})); /**
* @export
* @enum {string}
*/
var CreateDiscountTypeItemDateWeekdaysEnum;
(function (CreateDiscountTypeItemDateWeekdaysEnum) {
    CreateDiscountTypeItemDateWeekdaysEnum["Monday"] = "monday";
    CreateDiscountTypeItemDateWeekdaysEnum["Tuesday"] = "tuesday";
    CreateDiscountTypeItemDateWeekdaysEnum["Wednesday"] = "wednesday";
    CreateDiscountTypeItemDateWeekdaysEnum["Thursday"] = "thursday";
    CreateDiscountTypeItemDateWeekdaysEnum["Friday"] = "friday";
    CreateDiscountTypeItemDateWeekdaysEnum["Saturday"] = "saturday";
    CreateDiscountTypeItemDateWeekdaysEnum["Sunday"] = "sunday";
})(CreateDiscountTypeItemDateWeekdaysEnum = exports.CreateDiscountTypeItemDateWeekdaysEnum || (exports.CreateDiscountTypeItemDateWeekdaysEnum = {}));
function CreateDiscountTypeFromJSON(json) {
    return CreateDiscountTypeFromJSONTyped(json, false);
}
exports.CreateDiscountTypeFromJSON = CreateDiscountTypeFromJSON;
function CreateDiscountTypeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'applicable_for': json['applicable_for'],
        'code': json['code'],
        'description': !runtime_1.exists(json, 'description') ? undefined : json['description'],
        'amount_type': !runtime_1.exists(json, 'amount_type') ? undefined : json['amount_type'],
        'discount_amount': !runtime_1.exists(json, 'discount_amount') ? undefined : json['discount_amount'],
        'is_custom_amount': !runtime_1.exists(json, 'is_custom_amount') ? undefined : json['is_custom_amount'],
        'valid_from': !runtime_1.exists(json, 'valid_from') ? undefined : (json['valid_from'] === null ? null : new Date(json['valid_from'])),
        'valid_to': !runtime_1.exists(json, 'valid_to') ? undefined : (json['valid_to'] === null ? null : new Date(json['valid_to'])),
        'item_date_from': !runtime_1.exists(json, 'item_date_from') ? undefined : (json['item_date_from'] === null ? null : new Date(json['item_date_from'])),
        'item_date_to': !runtime_1.exists(json, 'item_date_to') ? undefined : (json['item_date_to'] === null ? null : new Date(json['item_date_to'])),
        'item_date_weekdays': !runtime_1.exists(json, 'item_date_weekdays') ? undefined : json['item_date_weekdays'],
        'item_time_from': !runtime_1.exists(json, 'item_time_from') ? undefined : json['item_time_from'],
        'item_time_to': !runtime_1.exists(json, 'item_time_to') ? undefined : json['item_time_to'],
        'valid_offerings': !runtime_1.exists(json, 'valid_offerings') ? undefined : (json['valid_offerings'].map(_1.OfferingIdentifierRequestFromJSON)),
        'max_uses': !runtime_1.exists(json, 'max_uses') ? undefined : json['max_uses'],
        'site_id': json['site_id'],
    };
}
exports.CreateDiscountTypeFromJSONTyped = CreateDiscountTypeFromJSONTyped;
function CreateDiscountTypeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'applicable_for': value.applicable_for,
        'code': value.code,
        'description': value.description,
        'amount_type': value.amount_type,
        'discount_amount': value.discount_amount,
        'is_custom_amount': value.is_custom_amount,
        'valid_from': value.valid_from === undefined ? undefined : (value.valid_from === null ? null : value.valid_from.toISOString().substr(0, 10)),
        'valid_to': value.valid_to === undefined ? undefined : (value.valid_to === null ? null : value.valid_to.toISOString().substr(0, 10)),
        'item_date_from': value.item_date_from === undefined ? undefined : (value.item_date_from === null ? null : value.item_date_from.toISOString().substr(0, 10)),
        'item_date_to': value.item_date_to === undefined ? undefined : (value.item_date_to === null ? null : value.item_date_to.toISOString().substr(0, 10)),
        'item_date_weekdays': value.item_date_weekdays,
        'item_time_from': value.item_time_from,
        'item_time_to': value.item_time_to,
        'valid_offerings': value.valid_offerings === undefined ? undefined : (value.valid_offerings.map(_1.OfferingIdentifierRequestToJSON)),
        'max_uses': value.max_uses,
        'site_id': value.site_id,
    };
}
exports.CreateDiscountTypeToJSON = CreateDiscountTypeToJSON;
